import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { surface, shadowSoft, radiusLg, borderSoft, navy } from '../Layout/Resources/Theme'

const CardRoot = styled.div`
  background: ${surface};
  border-radius: ${radiusLg};
  box-shadow: ${shadowSoft};
  border: 1px solid ${borderSoft};
  overflow: hidden;
  animation: sp-fade-up 0.28s ease both;
`

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid ${borderSoft};
  background: ${surface};
`

const CardTitle = styled.div`
  font-weight: 700;
  color: ${navy};
  font-size: 1rem;
`

const CardBody = styled.div`
  padding: ${props => props.noPadding ? '0' : '16px 20px 20px'};
`

const SurfaceCard = ({ title, actions, children, className, bodyClassName, noPadding }) => {
  return (
    <CardRoot className={`sp-surface-enter ${className || ''}`}>
      {(title || actions) ? (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          {actions ? <div className="d-flex align-items-center" style={{ gap: 8 }}>{actions}</div> : null}
        </CardHeader>
      ) : null}
      <CardBody className={bodyClassName} noPadding={noPadding}>
        {children}
      </CardBody>
    </CardRoot>
  )
}

SurfaceCard.propTypes = {
  title: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  noPadding: PropTypes.bool
}

SurfaceCard.defaultProps = {
  title: null,
  actions: null,
  className: '',
  bodyClassName: '',
  noPadding: false
}

export default SurfaceCard
